import React, { useState, useEffect } from 'react'
import { Box, Stack, RangeInput as RangeInputG } from 'grommet'
import { useSelector, useDispatch } from 'react-redux'
import { Volume, VolumeMute } from 'grommet-icons'
import styled from 'styled-components'
import { setLightness } from 'polished'
import { cssVarPolished } from '../../utils/cssVarHelper'
import { Howler } from 'howler'
import InlineTooltipButton from './InlineTooltipButton' //use self make tip as mobile view not appear, this self make not function well in mobile
import { updateMusicVolume } from '../../redux/toolSettings/actions'
import { isMobile } from 'react-device-detect'
// const Button = styled(ButtonG)`
//   background-color: ${props =>
//     setLightness(
//       0.85,
//       cssVarPolished(props.theme.global.colors[props.colorB], '#222'),
//     )};
//   border-radius: 50%;
//   padding: 12px;
//   z-index: 10002;
// `

const VolumeButtonBox = styled(Stack)`
  position: absolute;
  bottom: ${props => (!props.isRTGFullScreen ? props.bottom : '1.5rem')};
  left: ${props => (!props.isRTGFullScreen ? props.left : '1.5rem')};
  z-index: 11;
  @media (max-width: 1225px) {
    display: none;
  }
`

const RangeInputBox = styled(Box)`
  border-radius: 50px;
  transition: height 0.5s cubic-bezier(0, 1, 0.5, 1), opacity 0.2s;
  overflow: hidden;
  background-color: ${props =>
    setLightness(
      0.85,
      cssVarPolished(props.theme.global.colors[props.colorB], '#222'),
    )};
  opacity: ${props => props.opacity};
`

const RangeInput = styled(RangeInputG)`
  transform: rotate(270deg);
  /* -webkit-appearance: slider-vertical; */
  /* width: 12px;
  height: 200px; */
  /* padding: 1rem 0 */
  width: 120px;
  border-color: transparent;
  background-color: transparent;
  transform-origin: center center;
  margin-top: 60px;
  margin-bottom: 92px;
`

const VolumeButton = ({
  bottom = '6.7rem',
  left = '1.5rem',
  isRTGFullScreen = false,
}) => {
  const { volume: volumePersist, soundOn: soundOnPersist } = useSelector(
    state => state.settings.music,
  )
  const [value, setValue] = useState(0.5)
  const [over, setOver] = useState(false)
  const [soundOn, setSoundOn] = useState(true)
  const dispatch = useDispatch()

  const onChangeHandler = event => {
    const newVolume = event.target.value
    let newSoundOn = soundOn
    Howler.volume(newVolume)
    if (newVolume > 0.0) {
      if (!soundOn) {
        newSoundOn = true
      }
    } else {
      newSoundOn = false
    }
    dispatch(updateMusicVolume(newVolume, newSoundOn))
  }

  const soundOnHandler = () => {
    let newVolume
    if (!soundOn) {
      newVolume = Howler.volume()
      Howler.mute(false)
    } else {
      newVolume = 0
      Howler.mute(true)
    }
    dispatch(updateMusicVolume(newVolume, !soundOn))
  }

  useEffect(() => {
    if (volumePersist !== value) {
      setValue(volumePersist)
    }

    if (soundOnPersist !== soundOn) {
      setSoundOn(soundOnPersist)
    }
  }, [volumePersist, soundOnPersist])

  useEffect(() => {
    if (!isMobile) {
      Howler.volume(volumePersist)
    }
  }, [])

  return (
    <VolumeButtonBox
      onMouseOver={() => setOver(true)}
      onFocus={() => setOver(true)}
      onBlur={() => setOver(false)}
      onMouseLeave={() => setOver(false)}
      anchor="bottom"
      bottom={bottom}
      left={left}
      isRTGFullScreen={isRTGFullScreen}
    >
      <RangeInputBox
        colorB="iconDark"
        align="center"
        width="4.2rem"
        height={!over ? '0px' : '17.6rem'}
        opacity={!over ? 0 : 1}
      >
        <RangeInput
          value={value}
          step={0.05}
          max={1.0}
          min={0}
          color="primary"
          onChange={onChangeHandler}
        />
      </RangeInputBox>
      {/* <InBetweenBox
        width="4.2rem"
        height="2.1rem"
        // background="baseBackground"
      ></InBetweenBox> */}
      <InlineTooltipButton
        icon={
          soundOn ? (
            <Volume color="iconDark" size="small" />
          ) : (
            <VolumeMute color="iconDark" size="small" />
          )
        }
        message={soundOn ? 'Mute' : 'Unmute'}
        position="right"
        color="iconDark"
        clicked={soundOnHandler}
      />
    </VolumeButtonBox>
  )
}

export default VolumeButton
